var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBfiFinanceEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14712 12.0816C1.60045 12.6683 2.42712 12.775 3.01378 12.335L4.33378 11.3216V22.495C4.33378 23.2283 4.93378 23.8283 5.66712 23.8283H24.3338C25.0671 23.8283 25.6671 23.2283 25.6671 22.495V11.3216L26.9871 12.335C27.5738 12.7883 28.4138 12.6683 28.8538 12.0816C29.3071 11.495 29.1871 10.655 28.6004 10.215L15.8004 0.441631C15.3204 0.0816309 14.6538 0.0816309 14.1871 0.441631L1.38712 10.215C0.813783 10.6683 0.693783 11.5083 1.14712 12.0816ZM9.66712 15.8283C8.93378 15.8283 8.33378 15.2283 8.33378 14.495C8.33378 13.7616 8.93378 13.1616 9.66712 13.1616C10.4004 13.1616 11.0004 13.7616 11.0004 14.495C11.0004 15.2283 10.4004 15.8283 9.66712 15.8283ZM15.0004 15.8283C14.2671 15.8283 13.6671 15.2283 13.6671 14.495C13.6671 13.7616 14.2671 13.1616 15.0004 13.1616C15.7338 13.1616 16.3338 13.7616 16.3338 14.495C16.3338 15.2283 15.7338 15.8283 15.0004 15.8283ZM20.3338 15.8283C19.6004 15.8283 19.0004 15.2283 19.0004 14.495C19.0004 13.7616 19.6004 13.1616 20.3338 13.1616C21.0671 13.1616 21.6671 13.7616 21.6671 14.495C21.6671 15.2283 21.0671 15.8283 20.3338 15.8283Z",
    fill: "#23539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfiFinanceEmployees);
export default __webpack_public_path__ + "static/media/BFIFinanceEmployees.7517843838a698b5901f8925cd4bfafe.svg";
export { ForwardRef as ReactComponent };